const E2E_MODE_STORAGE_KEY = 'e2e-mode';

export const isE2EMode = (): boolean => {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage?.getItem(E2E_MODE_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

const disableInE2E = <T>(value: T): T | undefined => (isE2EMode() ? undefined : value);

export default disableInE2E;
